import { configureStore } from '@reduxjs/toolkit'
import userReducer from '../features/userSlice'
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import syncReducer from '../reducers/syncReducer';
const persistConfig = {
  key: "root",
  storage,
};
const reducer = combineReducers({
  user: userReducer,
  sync: syncReducer,
})
const persistedReducer = persistReducer(persistConfig, reducer);
export const store = configureStore({
  reducer: persistedReducer
})